export default __webpack_public_path__ + "static/graphik-web-black-e6f508174f3a95656414c729a3617499.woff";